/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Lotus Health
 * OpenAPI spec version: 0.0.0
 */

export type APILevelT = (typeof APILevelT)[keyof typeof APILevelT];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const APILevelT = {
  demo: "demo",
  app: "app",
} as const;
